// Common database operation types
export interface DatabaseResult<T> {
  data: T | null;
  error: any;
}

export interface DatabaseArrayResult<T> {
  data: T[] | null;
  error: any;
}

// Modern input types for the repository pattern

export interface StudentUserInput {
  username: string;
  email: string;
  password: string;
  dob: string;
  first_name: string;
  last_name: string;
}

export interface UserLanguage {
  user_type: string;
  language: string;
}

// Modern repository interface types - these define the contracts for our repositories
// Note: The actual implementations are in the repository classes, these are just for type checking

// Table name constants (moved from const.ts for better organization)
export const TABLE_NAMES = {
  USER: 'user',
  LIBRARY: 'library',
  STUDENT: 'students',
  CLASS: 'classes',
  SEMESTER: 'semester',
  HOMEWORK: 'homework',
  HOMEWORK_STUDENT_RELATION: 'homework_student_relation',
  HOMEWORK_ARTICLE_CACHE: 'homework_article_cache',
  HOMEWORK_STUDENT_CACHE: 'homework_student_cache',
  HOMEWORK_CLASS_CACHE: 'homework_class_cache',
  USER_LANGUAGE: 'user_language',
} as const;

export type TableName = (typeof TABLE_NAMES)[keyof typeof TABLE_NAMES];
